//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function get_basket(query) {
    // console.log("get_basket -> query", query);
    const url = process.env.LETS_TRADE_BASKET_URL ?? "";
    // console.log("url", url);
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/basket${objectToQueryString(query)}`,
        // content: request,
    });
}
export { 
// IGetBasketRequest,
get_basket, };
